import {List} from "immutable";
import TermExpander from "./term-expander.js";
import TokenExpander from "./token-expander";
import {Scope, freshScope} from "./scope";
import  * as _ from "ramda";
export default class Expander {
  constructor(context_304) {
    this.context = context_304;
  }
  expand(stxl_305) {
    let tokenExpander_306 = new TokenExpander(this.context);
    let termExpander_307 = new TermExpander(this.context);
    return _.pipe(_.bind(tokenExpander_306.expand, tokenExpander_306), _.map(t_308 => termExpander_307.expand(t_308)))(stxl_305);
  }
}
